// extracted by mini-css-extract-plugin
module.exports = {"iframe":"EmbedDataWrapper_iframe__4FKNW"};